import React, {
  useCallback, useEffect, useState
}  from 'react';
import { MemoryRouter, Redirect, Route, Switch, useHistory } from 'react-router-dom';
import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Box, Button,
  Toolbar, IconButton, Typography,
} from '@mui/material';

import RobotDashboardContainer  from './robot';
import ErrorBoundary from './components/errorBoundles';
import RobotProductsContainer from './robot/products';
import RobotSelectionsContainer from './robot/selections';
import RobotOutLibContainer from './robot/outLibs';
import RobotSelectionsListContainer from './robot/selectionsList';
import RobotProductDetailViewContainer from './robot/productDetailView';
import RobotCalculatorContainer from './robot/calculators';
import RobotAppCaseContainer from './robot/appcase';
import CacheRoute, { CacheSwitch, dropByCacheKey, getCachingKeys } from 'react-router-cache-route'
import RobotIntelligentContainer from './robot/intelligent';
import SolutionContainer from './robot/sv/solution';
import { SVSelectionsContainer } from './robot/inv/selections';
import IndustrialContainer from './robot/inv/Industrial';
import FunctionalContainer from './robot/inv/Functional';
import AboutContainer from './robot/about';
import ContactContainer from './robot/contact';
import FunctionalCharactContainer from './robot/HMI/FunctionalCharact';
import OperationContainer from './robot/EDM/Operation';
import FunctionIntrolContainer from './robot/EDM/FunctionIntrol';
import ProcessingContainer from './robot/EDM/Processing';
import LMOperationContainer from './robot/LM/LMOperation';
import LMFunctionIntrolContainer from './robot/LM/LMFunctionIntrol';
import LMProcessingContainer from './robot/LM/LMProcessing';
import FileDownloadContainer from './robot/filesDownload';



const useStyles = makeStyles((theme: Theme) => createStyles({
  contentWithSidebar: {
    "@media (min-width: 768px)": {
      marginTop:theme.spacing(0),
     },
     "@media (max-width: 768px)": {
      marginTop:theme.spacing(0),
     },
    display: 'flex',
    overflow:'auto',
    flexGrow: 1,
    heigt:'0px',
    flexBasis:0,
    justifyContent:'center',
    backgroundImage:`url('/images/background.png')`,
    backgroundSize:'cover',

  },
  test:{height:'100%'},
  content: {
    display: 'flex',
    flexDirection: 'column',
    // flexGrow: 1,
    // flexBasis: 0,
   
    // background: theme.palette.grey[50],
    "@media (min-width: 768px)": {
      padding: theme.spacing(2, 2, 0, 2),
      width:'80%',
     },
     "@media (max-width: 768px)": {
      padding: theme.spacing(0, 0, 0, 0),
      width:'100%',
     },
    
  },
}));

export function TipsDialog({ onClose }) {
  return (
    <Box>
      <DialogTitle>提示</DialogTitle>
      <DialogContent style = {{ minHeight: '60px' }}>请前往管理后台-设置-基本信息 完善邮箱信息。</DialogContent>
      <DialogActions style={{ backgroundColor: '#f5f5f5', justifyContent: 'flex-end' }}>
        {/* <Button onClick={onCancel}>取消</Button> */}
        <Button color="primary" variant='contained'
          onClick={onClose} style={{ marginLeft: '8px' }}
        >
          前往
        </Button>
      </DialogActions>
    </Box>
  );
}

export const WebSiteRouters = (props) => {
  const history = useHistory();
  const {doLogin} = props;

  const urlParams = new URL(window.location.href);
  const pathname = urlParams?.pathname;
  if(pathname.indexOf("/robot/productDetail") == -1&&pathname.indexOf("/inv/productDetail") == -1&&pathname.indexOf("/sv/productDetail") == -1&&pathname.indexOf("/plc/productDetail") == -1&&pathname.indexOf("/lv/productDetail") == -1&&pathname.indexOf("/got/productDetail") == -1&&pathname.indexOf("/edm/productDetail") == -1){
    dropByCacheKey('product')
  }
  const classes = useStyles();
  return (
    <div id='top' className={classes.contentWithSidebar} >
      <ErrorBoundary>
        <div className={classes.content}>
          <CacheSwitch>
            <Route exact path={[ '/robot','/sv','/inv','/plc','/lv','/got','/edm','/lm' ]} >
              <RobotDashboardContainer setParents = {props.setParents} setTitle={props.setTitle}/>
            </Route>
            <Route exact path={[ '/inv/selections','/sv/selections','/plc/selections','/lv/selections','/got/selections','/edm/selections','/lm/selections' ]} >
              <SVSelectionsContainer setParents={props.setParents} setTitle={props.setTitle} OpenUrl={props.OpenUrl}/>
            </Route>
            
            <CacheRoute  cacheKey={'product'} when={'forward'} className={classes.test}  exact path={[ '/robot/product','/robot/product/:id', '/robot/product/:id/:extra','/sv/product', '/sv/product/:id', '/sv/product/:id/:extra' ,'/inv/product', '/inv/product/:id/','/inv/product/:id/:extra','/plc/product', '/plc/product/:id/','/plc/product/:id/:extra','/lv/product', '/lv/product/:id/','/lv/product/:id/:extra','/got/product', '/got/product/:id/','/got/product/:id/:extra','/edm/product', '/edm/product/:id/','/edm/product/:id/:extra','/lm/product', '/lm/product/:id/','/lm/product/:id/:extra']} >
              <RobotProductsContainer setParents={props.setParents} setTitle={props.setTitle} OpenUrl={props.OpenUrl}/> 
            </CacheRoute >
            <CacheRoute when={'forward'} cacheKey={'selections'}
              className={classes.test} exact path={[ '/robot/selections','/sv/selections','/inv/selections','/plc/selections','/lv/selections','/got/selections','/edm/selections','/lm/selections' ]} >
              <RobotSelectionsContainer setParents={props.setParents} setTitle={props.setTitle}/>
            </CacheRoute>
            <CacheRoute when={'forward'}  cacheKey={'selectList'}  className={classes.test}  exact path={[ '/robot/selectList', '/robot/selectList/:base64Info']} >
              <RobotSelectionsListContainer setParents={props.setParents} setTitle={props.setTitle}/>
            </CacheRoute>
            <Route    exact path={[ '/robot/outlibs', '/robot/outlibs/:id','/inv/outlibs', '/inv/outlibs/:id','/sv/outlibs', '/sv/outlibs/:id','/plc/outlibs', '/plc/outlibs/:id','/lv/outlibs', '/lv/outlibs/:id','/got/outlibs', '/got/outlibs/:id','/edm/outlibs', '/edm/outlibs/:id' ,'/lm/outlibs', '/lm/outlibs/:id']} >
              <RobotOutLibContainer  doLogin={doLogin} setParents={props.setParents} setTitle={props.setTitle} OpenUrl={props.OpenUrl}/>
            </Route>
            <Route    exact path={[ '/assets', '/assets/:id']} >
              <FileDownloadContainer doLogin={doLogin} setParents={props.setParents} setTitle={props.setTitle}/>
            </Route>
            
            <Route  exact path={['/robot/productDetail/:id','/sv/productDetail/:id','/inv/productDetail/:id','/plc/productDetail/:id','/lv/productDetail/:id','/got/productDetail/:id','/edm/productDetail/:id','/lm/productDetail/:id' ]} >
              <RobotProductDetailViewContainer setParents={props.setParents} setTitle={props.setTitle} OpenUrl={props.OpenUrl}/>
            </Route> 
            {/* 产品计算器 */}
            <Route exact path={[ '/robot/calculator' ]} >
              <RobotCalculatorContainer setParents = {props.setParents} setTitle={props.setTitle} OpenUrl={props.OpenUrl}/>
            </Route>
            {/* 行业应用案例 */}
            <Route exact path={[ '/robot/appcase', '/robot/appcase/:secondId', '/robot/appcase/:secondId/:thirdId' ]} >
              <RobotAppCaseContainer setParents = {props.setParents} setTitle={props.setTitle} OpenUrl={props.OpenUrl}/>
            </Route>
            {/*伺服解决方案 */}
            <Route exact path={[ '/sv/solution', '/sv/solution/:secondId', '/sv/solution/:secondId/:thirdId' ]} >
              <SolutionContainer setParents = {props.setParents} setTitle={props.setTitle} OpenUrl={props.OpenUrl}/>
            </Route>
            <Route exact path={[ '/inv/industrial', '/inv/industrial/:secondId/:thirdId']} >
              <IndustrialContainer setParents = {props.setParents} setTitle={props.setTitle} OpenUrl={props.OpenUrl}/>
            </Route>
            <Route exact path={[ '/inv/functional', '/inv/functional/:secondId/:thirdId']} >
              <FunctionalContainer setParents = {props.setParents} setTitle={props.setTitle} OpenUrl={props.OpenUrl}/>
            </Route>
            <Route exact path={[ '/got/functional', '/got/functional/:secondId/:thirdId']} >
              <FunctionalCharactContainer setParents = {props.setParents} setTitle={props.setTitle} OpenUrl={props.OpenUrl}/>
            </Route>
            <Route exact path={[ '/edm/functional', '/edm/functional/:secondId/:thirdId']} >
              <OperationContainer setParents = {props.setParents} setTitle={props.setTitle} OpenUrl={props.OpenUrl}/>
            </Route>
            <Route exact path={[ '/edm/functionintrol', '/edm/functionintrol/:secondId/:thirdId']} >
              <FunctionIntrolContainer setParents = {props.setParents} setTitle={props.setTitle} OpenUrl={props.OpenUrl}/>
            </Route>
            <Route exact path={[ '/edm/processing', '/edm/processing/:secondId/:thirdId']} >
              <ProcessingContainer setParents = {props.setParents} setTitle={props.setTitle} OpenUrl={props.OpenUrl}/>
            </Route>
            <Route exact path={[ '/lm/functional', '/lm/functional/:secondId/:thirdId']} >
              <LMOperationContainer setParents = {props.setParents} setTitle={props.setTitle} OpenUrl={props.OpenUrl}/>
            </Route>
            <Route exact path={[ '/lm/functionintrol', '/lm/functionintrol/:secondId/:thirdId']} >
              <LMFunctionIntrolContainer setParents = {props.setParents} setTitle={props.setTitle} OpenUrl={props.OpenUrl}/>
            </Route>
            <Route exact path={[ '/lm/processing', '/lm/processing/:secondId/:thirdId']} >
              <LMProcessingContainer setParents = {props.setParents} setTitle={props.setTitle} OpenUrl={props.OpenUrl}/>
            </Route>
             {/* 智能化功能 */}
             <Route exact path={[ '/robot/intelligent', '/robot/intelligent/:secondId', '/robot/intelligent/:secondId/:thirdId' ]} >
              <RobotIntelligentContainer setParents = {props.setParents} setTitle={props.setTitle} OpenUrl={props.OpenUrl}/>
            </Route>
            <Route exact path={['/about']} >
              <AboutContainer setParents = {props.setParents} setTitle={props.setTitle} OpenUrl={props.OpenUrl}/>
            </Route>
            <Route exact path={['/contact']} >
              <ContactContainer setParents = {props.setParents} setTitle={props.setTitle} OpenUrl={props.OpenUrl}/>
            </Route>
            
          </CacheSwitch>
          
        </div>
      </ErrorBoundary>
    </div>
  );
};
